import React, { useEffect, useMemo, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import PrettyContainer from "../../prettyContainer/PrettyContainer";
import { getTrialsLog } from "../../../helpers/api";

const MUTED = "#6b7a90";
const VERDE = "#1f9d55";

// Registro de pruebas gratis (1 hora) que ya usaron los clientes, la mas
// reciente primero. Solo lectura.
export default function TrialLogPage() {
  const [filas, setFilas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [buscar, setBuscar] = useState("");

  useEffect(() => {
    getTrialsLog()
      .then((d) => setFilas(Array.isArray(d) ? d : []))
      .catch((m) => setError(String(m)))
      .finally(() => setLoading(false));
  }, []);

  const visibles = useMemo(() => {
    const q = buscar.trim().toLowerCase();
    if (!q) return filas;
    return filas.filter((f) =>
      [f.username, f.appName, f.phoneNumber, f.personalEmail, f.createdBy]
        .some((v) => String(v || "").toLowerCase().includes(q))
    );
  }, [filas, buscar]);

  const clientes = new Set(filas.map((f) => f.username)).size;
  const activas = filas.filter((f) => f.activa).length;
  const fecha = (d) => (d ? new Date(d).toLocaleString() : "—");

  const th = { padding: "8px 10px", textAlign: "left", fontSize: "0.8rem", color: MUTED, fontWeight: 700, whiteSpace: "nowrap", borderBottom: "1px solid #e6ebf2" };
  const td = { padding: "8px 10px", fontSize: "0.88rem", borderBottom: "1px solid #f0f3f7", verticalAlign: "top" };

  return (
    <PrettyContainer tittle="TRIAL LOG">
      <div style={{ paddingTop: "0.6em" }}>
        <p style={{ color: MUTED }}>
          Clients who used the 1-hour free trial. Each client can try each application only once.
        </p>

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px", color: MUTED }}>
            <Spinner animation="border" size="sm" /> Loading…
          </div>
        ) : error ? (
          <Alert variant="warning">{error}</Alert>
        ) : (
          <>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "14px", marginBottom: "12px", color: "#1d2735", fontSize: "0.9rem" }}>
              <span><b>{filas.length}</b> trials</span>
              <span><b>{clientes}</b> clients</span>
              <span style={{ color: VERDE }}><b>{activas}</b> in progress now</span>
            </div>

            <input
              type="search"
              className="form-control"
              placeholder="Search by user, application, phone…"
              value={buscar}
              onChange={(e) => setBuscar(e.target.value)}
              style={{ maxWidth: "420px", marginBottom: "12px" }}
            />

            {visibles.length === 0 ? (
              <div style={{ color: MUTED, padding: "16px 0" }}>
                {filas.length === 0 ? "No one has used a free trial yet." : "No results."}
              </div>
            ) : (
              <div style={{ overflowX: "auto", background: "#fff", borderRadius: "10px", border: "1px solid #e6ebf2" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={th}>User</th>
                      <th style={th}>Application</th>
                      <th style={th}>Started</th>
                      <th style={th}>Ends</th>
                      <th style={th}>Status</th>
                      <th style={th}>Phone</th>
                      <th style={th}>Email</th>
                      <th style={th}>Created by</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibles.map((f, i) => (
                      <tr key={f.username + "-" + f.app + "-" + i}>
                        <td style={{ ...td, fontWeight: 600 }}>{f.username}</td>
                        <td style={td}>{f.appName}</td>
                        <td style={{ ...td, whiteSpace: "nowrap" }}>{fecha(f.inicio)}</td>
                        <td style={{ ...td, whiteSpace: "nowrap" }}>{fecha(f.vence)}</td>
                        <td style={td}>
                          {f.activa ? (
                            <span style={{ color: VERDE, fontWeight: 700 }}>In progress</span>
                          ) : (
                            <span style={{ color: MUTED }}>Used</span>
                          )}
                        </td>
                        <td style={td}>{f.phoneNumber || "—"}</td>
                        <td style={td}>{f.personalEmail || "—"}</td>
                        <td style={td}>{f.createdBy || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </PrettyContainer>
  );
}
